// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternCTASet_root__tnWy4"};